import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {types} from 'main/tools';
import {CompanyInsuranceCarrier} from 'main/stores/benefits';

class PlanDirectoryState {
  store = new DomainStore();
  match;
  endpoint;

  companyInsuranceCarriers;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({match, endpoint}) {
    this.match = match;
    this.endpoint = endpoint;
  }

  async load() {
    await this.store._compose([this.endpoint]);

    this.companyInsuranceCarriers = this.store._getAll(
      types.COMPANY_INSURANCE_CARRIER, CompanyInsuranceCarrier
    );
  }
}

export default PlanDirectoryState;
